/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
// import "./src/styles/global.css";
// import "./src/styles/theme.css";
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { initGA, pageview } from "./src/utils/analytics";

// 初始化GA4
export const onClientEntry = () => {
  initGA();
};

export const wrapRootElement = ({ element }) => {
  return <HelmetProvider>{element}</HelmetProvider>;
};

export const onRouteUpdate = ({ location }) => {
  // 发送GA4页面浏览事件
  if (process.env.NODE_ENV === "production") {
    pageview(location.pathname + location.search);
  }
  
  if (typeof window !== 'undefined' && window.performance) {
    // 记录页面加载时间
    const timing = window.performance.timing;
    const navigationStart = timing.navigationStart;
    const loadTime = timing.loadEventEnd - navigationStart;
    console.log(`Page load time: ${loadTime}ms`);
    
    // 发送性能指标事件（可选）
    if (process.env.NODE_ENV === "production" && window.gtag) {
      window.gtag('event', 'performance_metrics', {
        event_category: 'Performance',
        event_label: location.pathname,
        value: loadTime,
        page_load_time: loadTime,
        non_interaction: true
      });
    }
  }
}
